























import Vue from 'vue';
import adBanner from '@/components/common/banner/adBanner.vue';

export default Vue.extend({
    components: {
        adBanner
    },
    data() {
        return {
            adPage: 'announce',
            adType: 'announceFundListBanner',
            totalPageCount: 0,
            announceList: []
        };
    },
    created() {
        this.getAnnounceList();
        if (this.$route.query.page === undefined || this.$route.query.page === 'fund') {
            this.adType = 'announceFundListBanner';
            let params: any = [
                {
                    name: '基金公告'
                }
            ];
            this.$store.commit('setBreadCrumbs', params);
        } else if (this.$route.query.page === 'frs') {
            this.adType = 'announceListBanner';
            let params: any = [
                {
                    name: '基富通公告'
                }
            ];
            this.$store.commit('setBreadCrumbs', params);
        }
    },
    methods: {
        getAnnounceList() {
            if (this.$route.query.page === undefined || this.$route.query.page === 'fund') {
                if (this.$route.query.pageIdx === undefined) {
                    window.FRSToolV3.getAnnounceList({ page: 1, type: 'fund' }).then((res: any) => {
                        this.announceList = res.result.data.articleList;
                        this.totalPageCount = parseInt(res.result.data.totalPageCount);
                    });
                } else {
                    window.FRSToolV3.getAnnounceList({ page: this.$route.query.pageIdx, type: 'fund' }).then((res: any) => {
                        this.announceList = res.result.data.articleList;
                        this.totalPageCount = parseInt(res.result.data.totalPageCount);
                    });
                }
            } else if (this.$route.query.page === 'frs') {
                if (this.$route.query.pageIdx === undefined) {
                    window.FRSToolV3.getAnnounceList({ page: 1, type: this.$route.query.page }).then((res: any) => {
                        this.announceList = res.result.data.articleList;
                        this.totalPageCount = parseInt(res.result.data.totalPageCount);
                    });
                } else {
                    window.FRSToolV3.getAnnounceList({ page: this.$route.query.pageIdx, type: this.$route.query.page }).then((res: any) => {
                        this.announceList = res.result.data.articleList;
                        this.totalPageCount = parseInt(res.result.data.totalPageCount);
                    });
                }
            }
        },
        clickMenu(page: any) {
            this.$router.push({ query: { page: page, pageIdx: undefined } });
            if (this.$route.query.page === undefined || this.$route.query.page === 'fund') {
                this.GAcode('基金公告');
                this.adType = 'announceFundListBanner';
                let params: any = [
                    {
                        name: '基金公告'
                    }
                ];
                this.$store.commit('setBreadCrumbs', params);
            } else if (this.$route.query.page === 'frs') {
                this.GAcode('基富通公告');
                this.adType = 'announceListBanner';
                let params: any = [
                    {
                        name: '基富通公告'
                    }
                ];
                this.$store.commit('setBreadCrumbs', params);
            }
            this.getAnnounceList();
        },
        changePage(val: any) {
            if (val - Number(this.$route.query.pageIdx) == -1) {
                this.GAcode('上一頁');
            } else if (val - Number(this.$route.query.pageIdx) == 1) {
                this.GAcode('下一頁');
            } else {
                this.GAcode('第' + val + '頁');
            }

            this.$router.push({ query: { page: this.$route.query.page, pageIdx: val } });
            if (this.$route.query.page === undefined || this.$route.query.page === 'fund') {
                window.FRSToolV3.getAnnounceList({ page: val, type: 'fund' }).then((res: any) => {
                    this.announceList = res.result.data.articleList;
                    this.totalPageCount = res.result.data.totalPageCount;
                });
            } else {
                window.FRSToolV3.getAnnounceList({ page: val, type: this.$route.query.page }).then((res: any) => {
                    this.announceList = res.result.data.articleList;
                    this.totalPageCount = res.result.data.totalPageCount;
                });
            }
        },
        GAcode(el: string) {
            if (typeof window.ActionAnalysisV2 !== 'undefined' && typeof el !== 'undefined') {
                window.ActionAnalysisV2.actClk(el);
            }
        }
    }
});
